import { render, staticRenderFns } from "./ProductDetailModal.vue?vue&type=template&id=382d9998&"
import script from "./ProductDetailModal.vue?vue&type=script&lang=ts&"
export * from "./ProductDetailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports